import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ImageEditorComponent} from '@syncfusion/ej2-angular-image-editor';
import {ExcTranslation} from 'exc-core-v2';
import {ExcDatePipe, ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../../../../services/enumeration.service';
import {ApplicationService} from '../../../../services/application.service';
import { L10n, setCulture } from '@syncfusion/ej2-base';
import {ExcFileItem} from 'exc-upload-v2';

@Component({
  selector: 'app-modal-image-editor',
  templateUrl: './modal-image-editor.component.html',
  styles: [
  ],
  providers: [ExcDatePipe]
})
export class ModalImageEditorComponent extends ExcTranslation implements OnInit {
  get dokTypIndex(): number {
    return this._dokTypIndex;
  }
  set dokTypIndex(index: number) {
    this._dokTypIndex = index;
    this.dok_enmIdent_DokTyp = this.enumSvc.getEnumerationList('DokTyp')[index].enmIdent;
  }
  @Input() data: any;
  dokID = '';
  newName = '';
  // tslint:disable-next-line:variable-name
  dok_enmIdent_DokTyp = 1;
  private _dokTypIndex = 1;
  baseImageIsEdited = false;
  @ViewChild('imageEditor')
  public imageEditorObj?: ImageEditorComponent;
  public toolbarItems: string[] = [
    'Crop',          // Zuschneiden
    'Straighten',    // Begradigen
    'Annotate',      // Anmerkung
    'Transform',     // Transformieren
    'Finetune',      // Feinabstimmung
    'Filter',        // Filter
    'Frame',         // Rahmen
    // 'Resize',        // Größe ändern
    'ZoomIn',        // Vergrößern
    'ZoomOut',       // Verkleinern
    // 'Save',          // Speichern
    // 'Open',          // Laden
    'Undo',          // Rückgängig
    'Redo',          // Wiederholen
    'Reset'          // Zurücksetzen
  ];
  userType: number | any;
  private selectedFiles: ExcFileItem[] = [];
  constructor(
    public excRest: ExcRestService,
    public modal: ExgModalService,
    public excSecurity: ExcSecurityService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private datePipe: ExcDatePipe) {
    super();
  }

  ngOnInit(): void {
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    if (this.data?.item?.dokID) {
      setCulture('de-DE');
      L10n.load({
        'de-DE': {
          'image-editor': {
            Crop: 'Zuschneiden',
            ZoomIn: 'Vergrößern',
            ZoomOut: 'Verkleinern',
            Undo: 'Rückgängig',
            Redo: 'Wiederholen',
            Transform: 'Transformieren',
            Annotation: 'Anmerkung',
            Finetune: 'Feinabstimmung',
            Brightness: 'Helligkeit',
            Contrast: 'Kontrast',
            Hue: 'Farbton',
            Saturation: 'Sättigung',
            Opacity: 'Deckkraft',
            Blur: 'Weichzeichnen',
            Sharpen: 'Schärfen',
            Exposure: 'Belichtung',
            Filter: 'Filter',
            Default: 'Standard',
            Chrome: 'Chrome',
            Cold: 'Kalt',
            Warm: 'Warm',
            Grayscale: 'Graustufen',
            BlackAndWhite: 'Schwarz-Weiß',
            Sepia: 'Sepia',
            Invert: 'Umkehren',
            Text: 'Text hinzufügen',
            Pen: 'Stift',
            Reset: 'Zurücksetzen',
            Save: 'Speichern',
            Select: 'Auswählen',
            RotateLeft: 'Nach links drehen',
            RotateRight: 'Nach rechts drehen',
            HorizontalFlip: 'Horizontal spiegeln',
            VerticalFlip: 'Vertikal spiegeln',
            OK: 'Anwenden',
            Cancel: 'Verwerfen',
            FillColor: 'Füllfarbe',
            StrokeColor: 'Linienfarbe',
            StrokeWidth: 'Linienbreite',
            FontFamily: 'Schriftfamilie',
            FontStyle: 'Schriftstil',
            FontSize: 'Schriftgröße',
            FontColor: 'Schriftfarbe',
            Pan: 'Verschieben',
            Move: 'Bewegen',
            Load: 'Laden',
            Custom: 'Benutzerdefiniert',
            Square: 'Quadrat',
            Circle: 'Kreis',
            Ellipse: 'Ellipse',
            Rectangle: 'Rechteck',
            Line: 'Linie',
            Arrow: 'Pfeil',
            Path: 'Pfad',
            Bold: 'Fett',
            Italic: 'Kursiv',
            BoldItalic: 'Fett Kursiv',
            XSmall: 'Sehr klein',
            Small: 'Klein',
            Medium: 'Mittel',
            Large: 'Groß',
            XLarge: 'Sehr groß',
            ABC: 'ABC',
            Browse: 'Durchsuchen',
            Duplicate: 'Duplizieren',
            Remove: 'Entfernen',
            EditText: 'Text bearbeiten',
            Start: 'Start',
            End: 'Ende',
            Bar: 'Leiste',
            ArrowSolid: 'gefüllter Pfeil',
            CircleSolid: 'gefüllter Kreis',
            SquareSolid: 'gefülltes Quadrat',
            None: 'Keine',
            CropAndTransform: 'Zuschneiden und Transformieren',
            CropSelection: 'Zuschneideauswahl',
            Image: 'Bild hinzufügen',
            Transparency: 'Transparenz',
            Height: 'Höhe',
            Width: 'Breite',
            AspectRatio: 'Seitenverhältnis beibehalten',
            W: 'B',
            H: 'H',
            DragText: 'Bild hierher ziehen oder',
            DropText: 'Bild hier ablegen oder',
            BrowseText: 'Hier durchsuchen...',
            SupportText: 'Unterstützt:',
            Frame: 'Rahmen',
            Mat: 'Eckig',
            Bevel: 'Abschrägung',
            Inset: 'Einlassung',
            Hook: 'Hakenrand',
            Color: 'Farbe',
            Size: 'Größe',
            Offset: 'Versatz',
            Radius: 'Radius',
            Amount: 'Menge',
            Resize: 'Größe ändern',
            Border: 'Rand',
            Solid: 'Durchgezogen',
            Dashed: 'Gestrichelt',
            Dotted: 'Gepunktet',
            GradientColor: 'Verlaufsfarbe',
            ConfirmDialogHeader: 'Änderungen speichern bestätigen',
            ConfirmDialogContent: 'Möchten Sie die Änderungen am Bild speichern?',
            AlertDialogHeader: 'Datei nicht unterstützt',
            AlertDialogContent: 'Die ausgewählte Datei wird nicht unterstützt.',
            Yes: 'Ja',
            No: 'Nein',
            ImageErrorDialogHeader: 'Bildauswahlfehler',
            ImageErrorDialogContent: 'Bitte wählen Sie nur ein Bild zum Öffnen aus.',
            Straighten: 'Begradigen',
            NoOutline: 'Keine Umrisse',
            DlgOK: 'OK',
            SaveAs: 'Speichern als',
            ImageName: 'Bildname',
            Format: 'Format',
            Quality: 'Qualität',
            Download: 'Herunterladen',
            Close: 'Schließen',
            ImageSize: 'Bildgröße',
            QualityInfo: 'Die Bildqualitätsoption ist nur für das JPEG-Format verfügbar',
            Good: 'Gut',
            Great: 'Großartig',
            Highest: 'Höchste',
            BringForward: 'Nach vorne bringen',
            SendBackward: 'Nach hinten senden',
            SendToBack: 'Ganz nach hinten senden',
            BringToFront: 'Ganz nach vorne bringen',
            ZOrder: 'Z-Reihenfolge'
          }
        }
      });
    }
    if (this.data?.item?.dokName) {
      this.newName = this.data.item.dokName;
    }
    if (this.data?.item?.dokIsEdited) {
      this.baseImageIsEdited = this.data.item.dokIsEdited;
    }
    if (this.data?.item?.dok_enmIdent_DokTyp > 0) {
      this.dokTypIndex = this.enumSvc.getEnumerationList('DokTyp').map(b => b.enmIdent).indexOf( this.data.item.dok_enmIdent_DokTyp);
    } else {
      this.dokTypIndex = this.enumSvc.getEnumerationList('DokTyp').map(b => b.enmIdent).indexOf( this.enumSvc.getEnumerationDefaultValue('DokTyp')); }
  }

  close(): void {
    this.modal.close();
  }
  save(): void {
    if (this.imageEditorObj) {
      const imageData = this.imageEditorObj.getImageData(); // Bilddaten als ImageData holen
      const canvas = document.createElement('canvas');
      canvas.width = imageData.width;
      canvas.height = imageData.height;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.putImageData(imageData, 0, 0);
        canvas.toBlob((blob) => {
          if (blob) {
            const formData = new FormData();
            formData.append('file[]', blob, this.newName + '.png');
            this.modal.action({ save: formData, dok_enmIdent_DokTyp: this.dok_enmIdent_DokTyp , dokID: this.data.item.dokID });
          }
        }, 'image/png');
      }
    }
  }

  saveAsNew(): void {
    if (this.imageEditorObj) {
      const imageData = this.imageEditorObj.getImageData(); // Bilddaten als ImageData holen
      const canvas = document.createElement('canvas');
      canvas.width = imageData.width;
      canvas.height = imageData.height;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.putImageData(imageData, 0, 0);
        canvas.toBlob((blob) => {
          if (blob) {
            const formData = new FormData();
            formData.append('file[]', blob, this.newName + '.png');
            this.modal.action({ saveAsNew: formData, dok_enmIdent_DokTyp: this.dok_enmIdent_DokTyp,
                                     dokID: this.data.item.dokID, selectedPage: this.data.item.selectedPage });
          }
        }, 'image/png');
      }
    }
  }


  editorCreated(): void {
    if (this.data?.item?.dokID && this.data.item.selectedPage ) {
      const URL = this.excRest.computeUrl('ImageThumbnailBig', { dokID: this.data.item.dokID, page: this.data.item.selectedPage - 1 });
      this.imageEditorObj?.open(URL);
    }
    else if (this.data?.item?.dokID) {
      const URL = this.excRest.computeUrl('ImageThumbnailBig', {dokID: this.data.item.dokID});
      this.imageEditorObj?.open(URL);
    }
    else {
      this.modal.close();
    }
  }

  resetCopy(): void {
    if ((this.data?.item?.dokCRU === this.excSecurity.UserName && this.userType === 2) || this.userType === 1) {
      this.modal.action({ reset: true, dokID: this.data.item.dokID });
    }
  }
}
